module.exports = __webpack_public_path__ + "static/media/BlogCaldasNovas1.dd3335ed.jpg";